export const environment = {
  production: false,

  // Auth URLs
  loginFlowUrl: '/api/v0/auth/login-flow',
  logoutFlowUrl: '/api/v0/auth/logout',

  // API Endpoints
  apiUrl: '/api/graphql/',

  // Tus server endpoint
  tusEndpoint: '/api/tus',

  // Jira Service Management — everything that changes per project.
  serviceDesk: {
    /** Public embed key of the portal's widget. */
    key: '73600119-f4a0-4d17-b6ff-93a36d1253a6',
    baseUrl: 'https://jsd-widget.atlassian.com/',
    contactEmail: 'servicedesk@geckosoft.it',
    presets: [
      {
        fieldId: 'customfield_10004',
        option: 'Moderate / Limited',
        hidden: true,
      },
      {
        fieldId: 'customfield_10075',
        option: 'Medium',
        hidden: false,
        /** Replaces the portal's select with an inline group, in this order. */
        choices: ['Critical', 'High', 'Medium', 'Low'],
      },
    ],
  },
};
